var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124.25,
    height: 124.251,
    viewBox: "0 0 124.25 124.251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-alt-circle-up",
    "data-name": "Icon awesome-arrow-alt-circle-up",
    d: "M.562,60.688a60.125,60.125,0,1,1,60.125,60.125A60.115,60.115,0,0,1,.562,60.688ZM71.355,88.811V60.688H88.544a2.911,2.911,0,0,0,2.061-4.97L62.749,28.007a2.883,2.883,0,0,0-4.1,0L30.771,55.718a2.909,2.909,0,0,0,2.061,4.97H50.02V88.811A2.918,2.918,0,0,0,52.93,91.72H68.446A2.918,2.918,0,0,0,71.355,88.811Z",
    transform: "translate(1.438 1.438)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUp);
export default __webpack_public_path__ + "static/media/icon-up.2397d628fe996f50bf906f1890a40547.svg";
export { ForwardRef as ReactComponent };